module.exports = __webpack_public_path__ + "img/instrument-offers.4f46dbcf.png";